import { SiteDrawer } from '../components/drawer'
import { SiteAppBar } from '../components/appbar'

export const DrawerLayout = ({ children, assignMulti, project }: any) => {
  console.log('with component: ', children)
  return (
    <>
      <SiteDrawer></SiteDrawer>
      <SiteAppBar project={project} assignMulti={assignMulti}></SiteAppBar>
      <div style={{ position: 'absolute', left: 250, right: 10, top: 80, bottom: 10 }}>
        {children}
      </div>
    </>
  )
}